import * as tslib_1 from "tslib";
import { RoleAuthService } from './../services/roleAuthService.service';
import { Location } from '@angular/common';
import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { ViewContainerRef, EventEmitter } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
var editRoleAuthorizationComponent = /** @class */ (function () {
    function editRoleAuthorizationComponent(mdmService, roleAuthService, toastr, location, vcr) {
        this.mdmService = mdmService;
        this.roleAuthService = roleAuthService;
        this.toastr = toastr;
        this.location = location;
        this.vcr = vcr;
        this.showChild = [];
        this.accessDenied = false;
        this.loader = true;
        this.saveChangesButton = false;
        this.pageList = [];
        this.pageSectionMap = new Map;
        this.mainPage = true;
        this.selectedAll = [];
        this.roleAuthList = [];
        this.raMap = new Map();
        this.raModifiedMap = new Map();
        this.paCntMap = new Map();
        this.selectedpsList = [];
        this.changes = false;
        this.roleId = [];
        this.onEdit = new EventEmitter;
        this.toastr.setViewRef(this.vcr);
    }
    editRoleAuthorizationComponent.prototype.ngOnChanges = function () {
        this.loadData();
    };
    editRoleAuthorizationComponent.prototype.loadData = function () {
        var self = this;
        self.loadPages().then(function (res) {
            self.loadRoleAuthorizations();
        }, function (err) {
            console.error(err);
        });
    };
    editRoleAuthorizationComponent.prototype.loadPages = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loader = true;
                        _a = this;
                        return [4 /*yield*/, this.roleAuthService.getPages()];
                    case 1:
                        _a.pageList = _b.sent();
                        this.loader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    editRoleAuthorizationComponent.prototype.loadRoleAuthorizations = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1, i;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loagPageSection();
                        this.loader = true;
                        this.selectedAll = [];
                        this.roleAuthList = [];
                        this.raModifiedMap.clear();
                        this.raMap.clear();
                        this.paCntMap.clear();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.roleAuthService.getRoleAuth(this.roleId)];
                    case 2:
                        _a.roleAuthList = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.roleAuthList = null;
                        return [3 /*break*/, 4];
                    case 4:
                        this.setRoleAuth();
                        for (i = 0; i < this.pageList.length; i++) {
                            this.setSelectedAll(i);
                        }
                        this.loader = false;
                        this.mainPage = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    editRoleAuthorizationComponent.prototype.loagPageSection = function () {
        var self = this;
        var secId = [];
        var pageId = [];
        self.pageList.forEach(function (page) {
            pageId.push(page.id);
            page.sections.forEach(function (section) {
                secId.push(section.id);
                self.pageSectionMap.set(page.id, secId);
            });
            secId = [];
        });
    };
    editRoleAuthorizationComponent.prototype.setRoleAuth = function () {
        var self = this;
        if (!self.roleAuthList)
            return;
        for (var _i = 0, _a = self.roleAuthList; _i < _a.length; _i++) {
            var raData = _a[_i];
            if (!self.raMap.has(raData.pageSectionId)) {
                self.raMap.set(raData.pageSectionId, raData.state);
                for (var _b = 0, _c = self.pageList; _b < _c.length; _b++) {
                    var paData = _c[_b];
                    for (var _d = 0, _e = paData.sections; _d < _e.length; _d++) {
                        var psData = _e[_d];
                        if (psData.id == raData.pageSectionId) {
                            if (!self.paCntMap.has(paData.id)) {
                                self.paCntMap.set(paData.id, 1);
                            }
                            else {
                                var value = self.paCntMap.get(paData.id);
                                self.paCntMap.set(paData.id, value + 1);
                            }
                        }
                    }
                }
            }
        }
    };
    editRoleAuthorizationComponent.prototype.selectAll = function (pageId, index, state) {
        var self = this;
        self.saveChangesButton = true;
        var raData;
        var psList = self.pageSectionMap.get(pageId);
        self.selectedAll[index] = state;
        for (var _i = 0, psList_1 = psList; _i < psList_1.length; _i++) {
            var psId = psList_1[_i];
            state != 1 ? self.raMap.set(psId, state) && self.paCntMap.set(pageId, psList.length) :
                self.raMap.set(psId, state) && self.paCntMap.set(pageId, 0);
            raData = { pageId: pageId, pageSectionId: psId, state: state };
            self.raModifiedMap.set(psId, raData);
        }
        self.selectedpsList[index] = null;
    };
    editRoleAuthorizationComponent.prototype.onChange = function (pageId, psId, index, chbox) {
        var self = this;
        // let pageId = +event.target.value;
        // let psId = +event.target.id;
        // let chbox = event.target.checked;
        self.saveChangesButton = true;
        var raData = { pageId: pageId, pageSectionId: psId, state: chbox, deleted: chbox == 1 ? true : false };
        // let value = 0;
        // if (self.paCntMap.has(raData.pageId)) {
        //     value = self.paCntMap.get(raData.pageId);
        // }
        // chbox ? self.paCntMap.set(raData.pageId, value + 1) :
        //     self.paCntMap.set(raData.pageId, value - 1);
        var prevState = self.raMap.has(psId) ? self.raMap.get(psId) : chbox;
        self.raMap.set(psId, chbox);
        var value = self.paCntMap.has(pageId) ? self.paCntMap.get(pageId) : 0;
        if (prevState == 1 && chbox != 1) {
            self.paCntMap.set(pageId, value + 1);
        }
        else if (prevState != 1 && chbox == 1) {
            self.paCntMap.set(pageId, value - 1);
        }
        else if (prevState == chbox && chbox != 1) {
            self.paCntMap.set(pageId, value + 1);
        }
        self.setSelectedAll(index);
        self.raModifiedMap.set(psId, raData);
    };
    editRoleAuthorizationComponent.prototype.SaveChanges = function () {
        var self = this;
        self.OnSaveChanges().then(function (res) {
            if (res) {
                self.rolesBack();
            }
        }, function (err) {
            self.changes = false;
        });
    };
    editRoleAuthorizationComponent.prototype.OnSaveChanges = function () {
        var self = this;
        var psIdList_save = [];
        var psIdList_del = [];
        self.pageSectionMap.forEach(function (page) {
            if (page != undefined) {
                page.forEach(function (psId) {
                    var data = self.raModifiedMap.has(psId) ? self.raModifiedMap.get(psId) : null;
                    if (data != null) {
                        var authData = { pageSectionId: data.pageSectionId, state: data.state };
                        (data.state != 1) ? psIdList_save.push(authData) :
                            psIdList_del.push(authData);
                    }
                });
            }
        });
        var IdList_del = [];
        if (self.roleAuthList != null) {
            if (psIdList_del && psIdList_del.length) {
                psIdList_del.forEach(function (ele) {
                    var psId;
                    self.roleAuthList.forEach(function (prevAuth) {
                        if (ele.pageSectionId == prevAuth.pageSectionId && ele.state != prevAuth.state) {
                            psId = ele;
                        }
                    });
                    psId ? IdList_del.push(psId) : null;
                });
            }
        }
        if (self.roleAuthList != null) {
            if (psIdList_save && psIdList_save.length) {
                self.roleAuthList.forEach(function (prevAuth) {
                    psIdList_save.forEach(function (ele, i) {
                        if (ele.pageSectionId == prevAuth.pageSectionId && ele.state == prevAuth.state) {
                            psIdList_save.splice(i, 1);
                        }
                    });
                });
            }
        }
        var finalList = IdList_del && IdList_del.length ? IdList_del.concat(psIdList_save) : psIdList_save;
        return new Promise(function (resolve, reject) {
            if (finalList && finalList.length) {
                self.loader = true;
                self.roleAuthService.editOrSave('/save', finalList, self.roleId).then(function (res) {
                    if (res && res.success) {
                        self.changes = true;
                        self.loader = false;
                        self.toastr.showSuccess('Changes saved successsfully');
                        resolve('success');
                    }
                    else if (res && !res.success) {
                        self.loader = false;
                        self.toastr.showError('Failed to save changes');
                        resolve('error');
                    }
                });
            }
            else {
                resolve('null');
            }
        });
        // console.log(psIdList_save);
        // console.log(psIdList_del);           
        // return;
        // if (psIdList_del.length || psIdList_save.length) {
        //     self.loader = true;
        //     self.roleAuthList == null ? psIdList_del = [] : null;
        //     self.removeAuth(psIdList_del).then((res) => {
        //         self.addAuth(psIdList_save).then((res) => {
        //             self.changes = true;
        //             self.loader = false;
        //             resolve();
        //         });
        //     });
        // } else {
        //     self.loader = false;
        //     resolve();
        // };   
    };
    // removeAuth(psIdList) {
    //     let self = this;
    //     let npsIdList = [];
    //     return new Promise((resolve) => {
    //         if (!psIdList.length) resolve('');
    //         if (self.roleAuthList != null){
    //             psIdList.forEach(ele => {
    //                 let psId;
    //                 self.roleAuthList.forEach(prevAuth => {
    //                     if(ele.id == prevAuth.pageSectionId){
    //                         psId = ele;
    //                     }
    //                 });
    //                 psId ? npsIdList.push(psId) : null;
    //             });
    //         }else npsIdList = psIdList;
    //         if(npsIdList.length){
    //             self.roleAuthService.editOrSave('/remove', npsIdList, self.roleId).then((res) => {
    //                 resolve(res);
    //             });
    //         }else resolve('');
    //     });
    // }
    // addAuth(psIdList) {
    //     let self = this;
    //     return new Promise((resolve) => {
    //         if (!psIdList.length) resolve('');
    //         if (self.roleAuthList != null){
    //             self.roleAuthList.forEach(prevAuth => {
    //                 psIdList.forEach((ele,i) => {
    //                     if(ele.id == prevAuth.pageSectionId && ele.state == prevAuth.state){
    //                         psIdList.splice(i,1);
    //                     }
    //                 });
    //             });
    //         }
    //         if(psIdList.length){
    //             self.roleAuthService.editOrSave('/save', psIdList, self.roleId).then((res) => {
    //                 resolve(res);
    //             });
    //         }else resolve('');
    //     });
    // }
    editRoleAuthorizationComponent.prototype.toggleChild = function (i) {
        var self = this;
        self.showChild[i] = !self.showChild[i];
    };
    editRoleAuthorizationComponent.prototype.setSelectedAll = function (index) {
        var self = this;
        var enable = [];
        var disable = [];
        var lock = [];
        var flag = false;
        var i = index;
        // for (let i = 0; i < self.pageList.length; i++) {
        var psList = self.pageSectionMap.get(self.pageList[i].id);
        if (psList && psList.length == self.paCntMap.get(self.pageList[i].id)) {
            for (var j = 0; j < psList.length; j++) {
                if (self.raMap.get(psList[j]) == 0) {
                    enable.push(0);
                }
                else if (self.raMap.get(psList[j]) == 1) {
                    disable.push(1);
                }
                else if (self.raMap.get(psList[j]) == 2) {
                    lock.push(2);
                }
                this.selectedpsList[i] = null;
            }
            if (psList.length == enable.length) {
                self.selectedAll[index] = 0;
            }
            else if (psList.length == disable.length) {
                self.selectedAll[index] = 1;
            }
            else if (psList.length == lock.length) {
                self.selectedAll[index] = 2;
            }
            else {
                self.selectedAll[index] = 3;
            }
        }
        else {
            self.selectedAll[i] = 3;
            this.selectedpsList[i] = self.paCntMap.get(self.pageList[i].id);
        }
        if (!self.paCntMap.has(self.pageList[i].id) || self.paCntMap.get(self.pageList[i].id) == 0) {
            self.selectedAll[index] = 1;
        }
        // }
    };
    editRoleAuthorizationComponent.prototype.hasChilds = function () {
        return this.pageList.sections != null && this.pageList.sections.length > 0;
    };
    editRoleAuthorizationComponent.prototype.rolesBack = function () {
        this.onEdit.emit(this.changes);
    };
    return editRoleAuthorizationComponent;
}());
export { editRoleAuthorizationComponent };



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/editRoleAuthorization.component.ts.pre-build-optimizer.js